import { z } from 'zod';
export const DomainSecretVerificationSchema = z.object({
    accessToken: z.string(),
    domainSecret: z.string(),
});
